// extracted by mini-css-extract-plugin
export var modalFooter = "_l1-0";